import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp, Container } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { TIMER } from "../../core/utills";
import { actions as randomWildActions } from "../../gamereducer/randomWildReducer";
import withRetriggerPopupConfiguration from "./configuration/withRetriggerPopupConfiguration";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { actions as symbolActions } from "../../core/reducers/symbolStateReducer";
import { actions as reelgridAction } from '../../core/reducers/reelgridStateReducer';
import { actions as soundActions } from "../../core/reducers/soundReducer";


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class RetriggerPopup extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected RetriggerPopupContainer: any;
    protected ui_mode: string;
    protected displayUI: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.RetriggerPopupContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    bindUI() {
        this.layoutChange(this.props.layoutMode);
    }


    initializeObjectInVariable() {

    }

    handleRotation(isFeatureShown: any) {
        if (isFeatureShown) {

            let retriggerCount: any = UIManager.getRef("reTrigger_count_retrigger");


            /*  if (isMobile && window.innerHeight > window.innerWidth) {
 
 
 
                 retriggerCount && (retriggerCount.position.set(330, 860))
             } else {
 
                 //freespinText && (freespinText.position.set(716, 450))
                 retriggerCount && (retriggerCount.position.set(716, 450))
 
             } */

            //BuyFeature_Graphic && (BuyFeature_Graphic.visible = true)

            retriggerCount && (retriggerCount.visible = true);
            if (isMobile && window.innerWidth < window.innerHeight) {
                UIManager.getRef("Retrigger_Graphic1") && (UIManager.getRef("Retrigger_Graphic1").width = 1080);
                UIManager.getRef("Retrigger_Graphic1") && (UIManager.getRef("Retrigger_Graphic1").height = 1920);
                UIManager.getRef("popupContainer") && (UIManager.getRef("popupContainer").x = -406);
                UIManager.getRef("popupContainer") && (UIManager.getRef("popupContainer").y = 241);
                // UIManager.getRef("Retrigger_Graphic1") && (UIManager.getRef("Retrigger_Graphic1").x = 406);
                // UIManager.getRef("Retrigger_Graphic1") && (UIManager.getRef("Retrigger_Graphic1").y = 482);


            }
            else {
                UIManager.getRef("Retrigger_Graphic1") && (UIManager.getRef("Retrigger_Graphic1").width = 1920);
                UIManager.getRef("Retrigger_Graphic1") && (UIManager.getRef("Retrigger_Graphic1").height = 1080);
                UIManager.getRef("popupContainer") && (UIManager.getRef("popupContainer").x = 0);
                UIManager.getRef("popupContainer") && (UIManager.getRef("popupContainer").y = 0);
            }

        }

    }

    showRetriggerPopup(nextProps: any) {
        let reTriggerContainer = UIManager.getRef("popupContainer");
        let retriggerCount = UIManager.getRef("reTrigger_count_retrigger");

        retriggerCount.text = nextProps.retriggerCount;
        if (reTriggerContainer) {
            reTriggerContainer.alpha = 0;
            reTriggerContainer.visible = true;
            UIManager.getRef("Retrigger_Graphic1").visible = true;
            new Tween(
                [reTriggerContainer],
                {

                    'alpha': { start: 0, end: 1 }
                },
                0.2,
                easing.easeLinear,
                false, null, null, null, null, false, onchange, () => {

                }


            );

            new Tween(
                [UIManager.getRef("Retrigger_Graphic1")],
                {

                    'alpha': { start: 0, end: 1 }
                },
                0.2,
                easing.easeLinear,
                false, null, null, null, null, false, onchange, () => {

                }


            );
            let timer = TIMER.TimerManager.createTimer(2000);
            timer.on('end', (e: any, data: any) => {
                reTriggerContainer.visible = false;
                UIManager.getRef("Retrigger_Graphic1").visible = false;
            })
            timer.start();
        }
    }

    componentDidMount() {
        this.initializeObjectInVariable();
        this.bindUI();
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.layoutMode !== this.props.layoutMode ||
            nextProps.retriggerCount !== this.props.retriggerCount ||
            nextProps.allSoundSFXStop !== this.props.allSoundSFXStop ||
            nextProps.soundIsPlaying !== this.props.soundIsPlaying ||
            nextProps.isShowRetrigger !== this.props.isShowRetrigger
        ) {


            if (nextProps.isShowRetrigger && nextProps.isShowRetrigger !== this.props.isShowRetrigger) {
                if (nextProps.soundIsPlaying && !nextProps.allSoundSFXStop) {
                    this.props.playSound([{ name: "symbol_1", loop: false }]);
                }


                this.showRetriggerPopup(nextProps);
                this.handleRotation(nextProps.isShowRetrigger)
            }
            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode)
                this.handleRotation(nextProps.isShowRetrigger)
            }

            return false;
        }

        return true;
    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }

    componentDidUpdate() {
        this.showRetriggerPopup(this.props);
    }

    render() {

        return (
            <UIManager id={"RetriggerPopupContainer"} name={"RetriggerPopupContainer"} type={"Container"}
                ref={i => this.RetriggerPopupContainer = i} configGame={this.props.configGame}
                app={this.app} >
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                            scope={this} />
                    )
                }
            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'soundState' | 'RandomWildState' | 'retriggerState' | 'reelgridState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        isShowRetrigger: state.retriggerState.isShowRetrigger,
        retriggerCount: state.retriggerState.retriggerCount,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        soundIsPlaying: state.soundState.soundIsPlaying,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),

        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        resetRandomWild: (): any => (randomWildActions.resetRandomWild()),
        updateReelData: (result_reel: any): any => dispatch(reelgridAction.updateReelData(result_reel)),
        onUpdateSymbolOnReel: (symbol: any, symbolId: number, randomSymbol: boolean): any => dispatch(symbolActions.setUpdatedSymbol(symbol, symbolId, randomSymbol)),

    }))(withRetriggerPopupConfiguration(RetriggerPopup)));